export default "/images/404-page.jpg?9b1accfcc5cfb88f80d20aafc235bc43";